import { buildAccessorialChargeDraft, type LoadChargeDraft } from "../rating";

export interface DetentionDraftInput {
  tenantId: string;
  loadId: string;
  arrivalAt: string;
  releasedAt: string;
  freeMinutes?: number;
  rateCents?: number;
  facilitySignedSheetDocId?: string;
}

export interface DetentionDraft {
  charge: LoadChargeDraft;
  holdReason: string;
}

export function buildDetentionAutoDraft(input: DetentionDraftInput): DetentionDraft | null {
  const freeMinutes = input.freeMinutes ?? 120;
  const elapsedMinutes = Math.max(
    0,
    Math.round((Date.parse(input.releasedAt) - Date.parse(input.arrivalAt)) / 60_000),
  );
  if (elapsedMinutes <= freeMinutes) return null;

  const evidenceDocIds = input.facilitySignedSheetDocId ? [input.facilitySignedSheetDocId] : [];
  const charge = buildAccessorialChargeDraft({
    tenantId: input.tenantId,
    loadId: input.loadId,
    code: "detention",
    startedAt: input.arrivalAt,
    endedAt: input.releasedAt,
    freeMinutes,
    rateCents: input.rateCents,
    evidenceDocIds,
  });

  return {
    charge: {
      ...charge,
      missingEvidence: input.facilitySignedSheetDocId ? [] : ["facility-signed detention sheet"],
    },
    holdReason: input.facilitySignedSheetDocId
      ? "detention requires dispatcher approval before billing"
      : "facility-signed detention sheet required before billing",
  };
}
